import { Text, Flex, Input } from '@chakra-ui/react'
import { useEffect, useState } from 'react'

import { FormField } from '../../../components/FormField'
import { FormModal } from '../../../components/FormModal'
import { useUser } from '../../../contexts/UserContext'
import { useAppToast } from '../../../helpers'
import { IRoleGroup, IUserGroup, UserGroupService } from '../../../services/UserGroup/UserGroupService'
import { UserGroupPermissionsSelector } from './UserGroupPermissionsSelector'

interface IProps {
  isOpen: boolean
  onClose: () => void
  userGroup: IUserGroup
}

interface IForm {
  name: string
  permissions: number[]
}

export function UserGroupEditModal({ isOpen, onClose, userGroup }: IProps) {
  const toast = useAppToast()
  const userGroupService = new UserGroupService()
  const [form, setForm] = useState<IForm>({ name: userGroup.name, permissions: userGroup.roles.map((role) => role.id) })
  const [permissions, setPermissions] = useState<IRoleGroup[]>([])
  const [errors, setErrors] = useState<{ [key: string]: string[] }>({})
  const { fetchRoles } = useUser()

  const handleSave = async (event: React.FormEvent) => {
    event.preventDefault()

    if (!formValid()) {
      return
    }

    userGroupService
      .update(userGroup.id, form)
      .then(() => {
        toast.success('Grupo de Usuários editado com sucesso')

        onClose()
      })
      .catch((error) => {
        setErrors(error.response.data.errors)
      })

    await fetchRoles()
  }

  const formValid = () => {
    return form.name && form.permissions
  }

  const loadPermissionsOptions = async () => {
    const data = await userGroupService.listSystemRoles()

    setPermissions(data)
  }

  useEffect(() => {
    if (!isOpen) {
      return
    }

    loadPermissionsOptions()
    setForm({ name: userGroup.name, permissions: userGroup.roles.map((role) => role.id) })
  }, [isOpen])

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title={`Editar grupo de usuários: ${userGroup.name}`}
      onSubmit={handleSave}
      size="editor"
      isConfirmDisabled={!formValid()}
    >
      <Flex direction="column">
        <FormField label="Nome" error={errors.name} isRequired>
          <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
        </FormField>

        <FormField label="Permissões" mt={4}>
          <UserGroupPermissionsSelector
            permissions={permissions}
            selected={form.permissions}
            onChange={(selected) => setForm({ ...form, permissions: selected })}
          />
        </FormField>
      </Flex>

      {!formValid() && (
        <Text variant="caption" mt={4}>
          Preencha todos os campos acima para prosseguir
        </Text>
      )}
    </FormModal>
  )
}
